import { useQuery } from "react-query";
import API from "../shared-utils/api";
export const getPubConfig = async (pub_id, areaName) => {
    const { data } = await API.get(`/api/v1/rbzo/pubs/${pub_id}/getConfig`, {
        params: areaName ? { areaName } : undefined,
    });
    return data;
};
export const usePubConfig = (pub_id, enabled = true, areaName) => {
    return useQuery(["pubConfig", pub_id, areaName || ""], () => getPubConfig(pub_id, areaName), {
        enabled: enabled && !!pub_id,
        cacheTime: 1000 * 60 * 10,
        staleTime: 1000 * 60 * 12,
    });
};
